module.exports = __webpack_public_path__ + "media/images/pubmatic_logo-3aa2b0a1a38b38b3794cbeabd4f71476.png";